import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type StickyErrorContainerClasses = 'errorContainer';

const stickyErrorContainerStyles = makeStyles<ISpcTheme, StickyErrorContainerClasses>(
  theme => ({
    errorContainer: {
      textAlign: 'center',
      display: 'block',
      maxWidth: '800px',
      minWidth: '250px',
      width: '70%',
      position: 'absolute',
      bottom: '105%',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '5px 15px',
      borderRadius: '10px',
      background: theme.palette.error.dark,
      color: theme.palette.common.white,
      boxShadow: '1px 1px 2px rgba(0,0,0,0.2)',
    },
  }),
  { name: 'Customise_StickyFooterContainer' },
);

export default stickyErrorContainerStyles;
